import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import jsPDF from 'jspdf';
import { useSelector } from 'react-redux';
import { fechaHoraActualBoliviaSoloVista } from '../../util/valueCalculator';
import { formatearFechaSimple } from '../../util/customFormatter';

const CustomPrintCert3 = ({ show, handleClose, afiliado, numeroCertificado, aserv, qrDataURL, certObjectText, copia }) => {
    const [pdfUrl, setPdfUrl] = useState(null);
    const { nombre: nombreUsuario } = useSelector(state => state.sesion);

    useEffect(() => {
        if (show) {
            generatePDF();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);

    const generatePDF = () => {
        const doc = new jsPDF({ orientation: 'portrait', unit: 'px', format: 'letter' });
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        const marginTop = 35;
        const marginBottom = 60;
        const marginLeftRight = 40;

        const day = new Date().getDate();
        const month = new Date().toLocaleString('es-ES', { month: 'long' });
        const year = new Date().getFullYear();

        const pronoun = afiliado.persona.genero === 'FEMENINO' ? 'la' : 'el';
        const inscritoHabilitado = afiliado.persona.genero === 'FEMENINO' ? 'inscrita' : 'inscrito';
        const habilitadoContextual = afiliado.persona.genero === 'FEMENINO' ? 'habilitada' : 'habilitado';
        const interesado = afiliado.persona.genero === 'FEMENINO' ? 'la interesada' : 'el interesado';

        // Marca de agua si es copia (BORRADOR)
        if (copia) {
            doc.setFontSize(60);
            doc.setTextColor(200, 200, 200);
            doc.text('S I N   V A L I D E Z', pageWidth / 2, pageHeight / 2, {
                align: 'center',
                angle: 10,
            });
        }
        doc.setTextColor(10, 10, 10);

        // ✅ SIN CABECERA (se quitó addHeader)
        // ✅ SIN NÚMERO (se quitó Nº ...)

        // Título
        

        // Subtítulo
        doc.setFont('times', 'italic');
        doc.setFontSize(10);
        //doc.text('(TRIBUNAL DE ETICA)', pageWidth / 2, marginTop + 55, { align: 'center' });

        // Texto institución
        doc.setFont('times', 'normal');
        doc.setFontSize(12);
        doc.text('EL TRIBUNAL DEPARTAMENTAL DE ETICA PROFESIONAL DEL COLEGIO DE ARQUITECTOS DE TARIJA, ', marginLeftRight, marginTop + 85);

        doc.setFont('times', 'bold');
        doc.setFontSize(28);
        doc.text('CERTIFICA', pageWidth / 2, marginTop + 100, { align: 'center' });

        doc.setFont('times', 'normal');
        doc.setFontSize(12);

        // Cuerpo principal
        // EN EL OTRO COLOCAR .... suspencion de las actividades institucionales....
        doc.text(
            `Que, revisados los Archivos del Tribunal Departamental de Etica Profesional,  evidencia que ${pronoun}` +
            `ARQ. ${afiliado.persona.nombre} ${afiliado.persona.apellido1 || ""} ${afiliado.persona.apellido2 || ""}, con C.I. ${afiliado.persona.ci}, ` +
            `se encuentra ${inscritoHabilitado} con el registro del Colegio de Arquitectos de Bolivia ` +
            `con el Nº ${afiliado.num_reg}, y a la fecha de emisión del presente certificado NO HA SIDO SANCIONADO, mediante fallo ejecutoriado con suspencion del ejercicio profesional`,             marginLeftRight,
            marginTop + 130,
            { maxWidth: pageWidth - marginLeftRight * 2, align: 'justify' }
        );

        // Objeto
        doc.text(
            `El presente certificado se extiende a solicitud de ${interesado} con el objeto determinado de:`,
            marginLeftRight,
            marginTop + 200,
            { maxWidth: pageWidth - marginLeftRight * 2, align: 'justify' }
        );

        const objeto = (certObjectText || '').trim() || '—';

        // ✅ OBJETO A LA IZQUIERDA (sin centrado ni justify)
        const yObj = marginTop + 230;
        const maxW = pageWidth - (2 * marginLeftRight);
        const lineHeight = 12;

        doc.setFont('times', 'bold');
        doc.text('OBJETO:', marginLeftRight, yObj);
        doc.setFont('times', 'normal');

        const wrappedObj = doc.splitTextToSize(objeto, maxW);

        doc.text(
            wrappedObj,
            marginLeftRight,
            yObj + lineHeight,
            { maxWidth: maxW, align: 'left' }
        );

        const yAfterObj = yObj + lineHeight + (wrappedObj.length * lineHeight);

        // Cierre
        doc.text(
            'Es cuanto se certifica en honor a la verdad y para los fines consiguientes.',
            marginLeftRight,
            yAfterObj + 25,
            { maxWidth: maxW, align: 'justify' }
        );

        // Fecha
        doc.text(`Tarija, ${day} de ${month} de ${year}`, marginLeftRight, yAfterObj + 45);

        // ✅ SIN "Cc/Archivo"
        // ✅ SIN línea institucional
        // ✅ SIN pie institucional
        // ✅ SOLO “Impreso el...”
        doc.setFontSize(6);
        doc.text(
            `Impreso el: ${fechaHoraActualBoliviaSoloVista()} por: ${nombreUsuario || 'Desconocido'}`,
            pageWidth - marginLeftRight,
            pageHeight - 10,
            { align: 'right' }
        );

        // ✅ QR SE MANTIENE
        if (qrDataURL) {
            doc.addImage(qrDataURL, 'PNG', pageWidth - marginLeftRight - 80, pageHeight - marginBottom - 88, 80, 80);
        }

        const pdfBlob = doc.output('blob');
        const url = URL.createObjectURL(pdfBlob);
        setPdfUrl(url);
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Vista Previa del Certificado</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {pdfUrl ? (
                    <iframe src={pdfUrl} width="100%" height="500px" title="Vista previa del certificado" />
                ) : (
                    <p>Cargando vista previa...</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cerrar
                </Button>
                <Button variant="primary" onClick={() => window.open(pdfUrl, '_blank')}>
                    Descargar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CustomPrintCert3;